import ScatterJS from "@scatterjs/core";
import ScatterEOS from "@scatterjs/eosjs2";
import { JsonRpc, Api } from "eosjs";
import dayjs from "dayjs";
import _ from "lodash";
import Axios from "axios";
import echarts from "echarts";


const SYS_SYMBOL = 'EOS';

const DEFAULT_PROXY = 'rexproxy1.tp'

const network = ScatterJS.Network.fromJson({
    blockchain: "eos",
    chainId: "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906",
    host: "eospush.tokenpocket.pro",
    port: 443,
    protocol: "https"
});
ScatterJS.plugins(new ScatterEOS());

const rpc = new JsonRpc(network.fullhost());
const requiredFields = { accounts: [network] };

let scatter = "";
let api = "";

export default {
    name: "HelloWorld",
    data() {
        return {
            currentAccount: null,
            currentPermission: null,
            rexFundBalance: '-',
            eosBalance: '-',
            rexBalance: null,
            maturedRex: 0,
            rexMaturities: [],
            fundAmount: null,
            fundWithdrawAmount: null,
            rexAmount: null,
            rexSellAmount: null,
            rexTotal: null,
            eosTotalLentable: null,
            eosTotalLent: null,
            eosTotalUnlent: null,
            eosTotalRent: null,
            stakedList: [],
            resReceiver: null,
            resPayment: null,
            resFund: null,
            resPrice: null,
            loanNum: null,
            rentChart: null,
            rexChart: null,
            myRexRecordList: [],
            resType: 'cpu',
            previousPage: false,
            isVoted: null,
            nextPage: false,
            pageStart: '',
            nextPageStart: '',
            pageNo: 1,
            pageCount: 10,
            rentList: [],
            tip1: '1',
            msg: '',
            sysSymbol: SYS_SYMBOL,
            defaultProxy: DEFAULT_PROXY,
            unstakedAccount: '',
            unstakedCpuLimit: '',
            unstakedNetLimit: '',
            unstakedCpu: 0,
            unstakedNet: 0,
            rentDetail: null,
            rentDetailType: null,
            resFundAmount: '',
            tabName: 'rex-tab',
            ramIncome: null,
            bidnameIncome: null,
            apr: '',
            rexStaked: '0',
            mvToSavingAmount: '',
            mvFrSavingAmount: '',
            rexQueue: 0,
            validRexQueue: 0,
            myQueueRex: 0,
            rexQueueInfo: null,
            myRexQueueStatus: null,
            myRexQueueIndex: null,
            loanTotalList: [],
            hasExpiredLoan: false,
            realQueue: []
        };
    },
    created() {
        this.checkTips();
        this.filter = localStorage.getItem("filter") || "active";
        this.sortBy = localStorage.getItem("sortby") || "mostVoter";

        setTimeout(() => {
            this.getTotalLoanOrder();
        }, 2000);


        this.getRexPool();

        this.getRexQueue();

        this.getOtherIncome();

        window.onresize = () => {
            if (this.rentChart) {
                this.rentChart.resize();
            }

            if (this.rexChart) {
                this.rexChart.resize();
            }
        };

        ScatterJS.scatter.connect("rex", { network }).then(connected => {
            if (!connected) return false;

            scatter = ScatterJS.scatter;

            window.ScatterJS = null;
            window.scatter = null;

            this.login();
        });
    },
    filters: {
        utcTime: function (input) {
            return dayjs(input + "Z").format("MM-DD HH:mm");
        },
        time: function (value) {

            if (!value) return ''

            return dayjs(value * 1000).format('YYYY-MM-DD HH:mm:ss');
        },
        number: function (input) {
            return parseFloat(input).toFixed(4);
        }
    },
    mounted() {
        this.getRexChart();
        this.getRentChart();
    },
    methods: {
        login() {
            if (scatter) {
                scatter
                    .getIdentity(requiredFields)
                    .then(identity => {
                        this.currentAccount = identity.accounts[0].name;

                        if (_hmt) {
                            try {
                                var referWallet = 'empty';
                                var ua = navigator.userAgent.toLowerCase();
                                if (ua.indexOf('tokenpocket') > -1) {
                                    referWallet = 'tp';
                                }
                                else if (ua.indexOf('meet') > -1) {
                                    referWallet = 'meetone';
                                }

                                else if (ua.indexOf('mykey') > -1) {
                                    referWallet = 'mykey';
                                }
                                else if (ua.indexOf('mathwallet') > -1) {
                                    referWallet = 'math';
                                }
                                else if (ua.indexOf('eostoken') > -1) {
                                    referWallet = 'eostoken'
                                }

                                _hmt.push(['_trackEvent', 'login', this.currentAccount, referWallet]);
                                _hmt.push(['_setCustomVar', 1, 'visitor', this.currentAccount, 1]);
                            }
                            catch (err) {
                                console.log(err);
                            }
                        }
                        this.resReceiver = this.currentAccount;
                        this.currentPermission = identity.accounts[0].authority;

                        api = scatter.eos(network, Api, { rpc });

                        this.getEosBalance();
                        // this.getMyRexRecords();
                        this.getMyqueue();
                        this.getRexFundBalance();
                        this.getRexBalance();
                        this.getStakedList();
                        this.getRentList();
                        this.getAccount();
                    })
                    .catch(err => {
                        this.handleError(err);
                    });
            }
        },
        logout() {
            if (scatter) {
                scatter.forgetIdentity();
                this.currentAccount = null;
                this.currentPermission = null;
                this.rexFundBalance = '-';
                this.eosBalance = '-';
                this.rexBalance = null;
                this.maturedRex = 0;
                this.rexMaturities = [];
                this.rexAmount = null;
                this.rexSellAmount = null;
                this.stakedList = [];
                this.myRexRecordList = [];
                this.previousPage = false;
                this.nextPage = false;
                this.pageStart = '';
                this.nextPageStart = '';
                this.pageNo = 1;
                this.pageCount = 10;
                this.rentList = [];
                this.myQueueRex = 0;
                this.myRexQueueIndex = null;
                this.myRexQueueStatus = null;
            }
        },
        cleanLoanList() {
            if (this.currentAccount) {
                api.transact({
                    "actions": [
                        {
                            "account": "eosio",
                            "name": "rexexec",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                user: this.currentAccount,
                                max: 30
                            }
                        }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    if (_hmt) {
                        try {
                            _hmt.push(['_trackEvent', 'rexexec', this.currentAccount]);
                        }
                        catch (err) {
                            console.log(err);
                        }
                    }
                    this.showMsg(this.$t('i18nView.success'));
                    setTimeout(() => this.getTotalLoanOrder(), 2000);
                }).catch(err => {
                    this.handleError(err);
                })
            }

        },
        viewRealQueue() {
            if (_hmt) {
                try {
                    _hmt.push(['_trackEvent', 'checkQueue', this.currentAccount || '-']);
                }
                catch (err) {
                    console.log(err);
                }
            }
            this.$modal.show('realRexQueue');
        },
        refreshLoanList() {
            this.getTotalLoanOrder();
        },
        refreshQueueList() {
            this.getRexQueue();
        },
        async getTotalLoanOrder() {
            try {


                var cpuList = await rpc.get_table_rows({
                    json: true,
                    code: 'eosio',
                    scope: 'eosio',
                    table: 'cpuloan',
                    table_key: 'time_point',
                    lower_bound: '',
                    upper_bound: '',
                    index_position: 2,
                    key_type: 'i64',
                    limit: 400
                })

                var netList = await rpc.get_table_rows({
                    json: true,
                    code: 'eosio',
                    scope: 'eosio',
                    table: 'netloan',
                    table_key: 'time_point',
                    lower_bound: '',
                    upper_bound: '',
                    index_position: 2,
                    key_type: 'i64',
                    limit: 100
                })

                var totalList = _.sortBy(cpuList.rows.concat(netList.rows), item => {
                    return item.expiration;
                });

                this.hasExpiredLoan = false;

                _.forEach(totalList, item => {
                    item.expireTime = dayjs(item.expiration + 'Z').format('MM-DD HH:mm:ss');

                    if (new Date(item.expiration + 'Z').getTime() < new Date().getTime()) {
                        this.hasExpiredLoan = true;
                    }

                    item.expried = new Date(item.expiration + 'Z').getTime() < new Date().getTime();
                })

                this.loanTotalList = totalList;

            }
            catch (err) {
                this.handleError(err);

            }

        },
        viewRestRex() {
            this.$modal.show('maturities');
        },
        manageRexSavings() {
            this.$modal.show('rexSavings');
        },
        openLoanStatus() {
            if (_hmt) {
                try {
                    _hmt.push(['_trackEvent', 'checkLoan', this.currentAccount || '-']);
                }
                catch (err) {
                    console.log(err);
                }
            }
            this.$modal.show('loanOrders')
        },
        getMyRexRecords() {

        },
        active(tabName) {
            this.tabName = tabName;
            setTimeout(() => {
                this.getRentChart();
                this.getRexChart();
            }, 100)

        },
        ikonw(tipName) {
            this[tipName] = '0';
            localStorage.setItem(tipName, '0');
        },
        checkTips() {
            this.tip1 = localStorage.getItem('tip1') || '1';
        },
        getOtherIncome() {
            Axios.get(
                "https://betaserver.mytokenpocket.vip/v1/rex/income?blockchain_id=4"
            ).then(res => {
                if (res.status === 200 && res.data.result === 0) {
                    this.ramIncome = parseFloat(res.data.data['eosio.ramfee']).toFixed(4) + ' ' + this.sysSymbol;
                    this.bidnameIncome = parseFloat(res.data.data['eosio.names']).toFixed(4) + ' ' + this.sysSymbol;
                }

            })
        },
        getRexPool() {
            rpc.get_table_rows({
                json: true,
                code: 'eosio',
                scope: 'eosio',
                table: 'rexpool',
                table_key: '',
                lower_bound: '',
                upper_bound: ''
            }).then(res => {
                if (res.rows.length) {
                    this.rexTotal = res.rows[0].total_rex;
                    this.eosTotalRent = res.rows[0].total_rent;
                    this.eosTotalLentable = res.rows[0].total_lendable;
                    this.eosTotalLent = res.rows[0].total_lent;
                    this.eosTotalUnlent = res.rows[0].total_unlent;
                    this.loanNum = res.rows[0].loan_num;

                    this.resPrice = parseFloat(
                        (1 * parseFloat(res.rows[0].total_unlent)) /
                        (parseFloat(res.rows[0].total_rent) + 1)
                    ).toFixed(4);

                    var priceIncrease = (parseFloat(this.eosTotalLentable) / parseFloat(this.rexTotal) - 0.0001) / 0.0001;
                    var dateIncrease = new Date().getTime() - new Date(dayjs("2019-05-01T12:47:00.000Z").format("YYYY/MM/DD HH:mm:ss")).getTime();
                    this.apr = parseFloat((priceIncrease / dateIncrease * 365 * 24 * 60 * 60 * 1000) * 100).toFixed(2) + '%';

                }
            }).catch(err => {
                if (err.status === 500) {
                    try {
                        var msg = JSON.parse(err.message);

                        if (msg.code === 500 && msg.error && msg.error.code === 3060003) {
                            this.showMsg(this.$t('i18nView.waitingForDeploy'));
                        }
                    } catch (e) { }
                }
            });
        },
        getRexQueue() {
            rpc.get_table_rows({
                json: true,
                code: 'eosio',
                scope: 'eosio',
                table: 'rexqueue',
                table_key: 'timeorder_time_point',
                lower_bound: '',
                upper_bound: '',
                index_position: 2,
                key_type: 'i64',
                limit: 300
            }).then(res => {
                this.rexQueue = res.rows.length;

                if (res.rows.length > 0) {
                    this.rexQueueInfo = res.rows;

                    this.realQueue = _.filter(this.rexQueueInfo, item => {
                        item.createTime = dayjs(item.order_time + 'Z').format('MM-DD HH:mm:ss');
                        return item.is_open === 1;
                    })

                    this.checkMyRexQueue();

                    var isFind = false;
                    _.forEach(this.rexQueueInfo, (value, index) => {
                        if (value.is_open === 0 && !isFind) {
                            this.validRexQueue = index;
                            isFind = true;
                        }
                    })
                }
            })
        },
        checkMyRexQueue() {
            if (this.rexQueueInfo && this.myQueueRex !== 0) {
                _.forEach(this.rexQueueInfo, (item, index) => {
                    if (item.owner === this.currentAccount) {
                        this.myRexQueueStatus = item.is_open;
                        this.myRexQueueIndex = index + 1;
                    }
                })
            }
        },
        cancelRexQueue() {
            if (this.currentAccount) {

                api.transact({
                    "actions": [
                        {
                            "account": "eosio",
                            "name": "cnclrexorder",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                owner: this.currentAccount
                            }
                        }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'));
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        updateRexStatus() {
            if (this.currentAccount) {
                if (_hmt) {
                    try {
                        _hmt.push(['_trackEvent', 'updaterex', this.currentAccount]);
                    }
                    catch (err) {
                        console.log(err);
                    }
                }

                api.transact({
                    "actions": [
                        {
                            "account": "eosio",
                            "name": "updaterex",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                owner: this.currentAccount
                            }
                        }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'));
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        getMyqueue() {
            if (this.currentAccount) {
                rpc.get_table_rows({
                    json: true,
                    code: 'eosio',
                    scope: 'eosio',
                    table: 'rexqueue',
                    table_key: '',
                    lower_bound: this.currentAccount + ' ',
                    upper_bound: this.currentAccount + ' ',
                    limit: 1
                }).then(res => {
                    if (res.rows.length) {
                        this.myQueueRex = res.rows[0].rex_requested;
                        this.checkMyRexQueue();
                    }
                    else {
                        this.myQueueRex = 0;
                    }
                })
            }
        },
        getRentList() {
            this.rentList = [];
            if (this.currentAccount) {
                rpc.get_table_rows({
                    json: true,
                    code: 'eosio',
                    scope: 'eosio',
                    table: 'cpuloan',
                    table_key: '',
                    lower_bound: this.currentAccount,
                    upper_bound: this.currentAccount,
                    index_position: 3,
                    key_type: 'name',
                    limit: 100
                }).then(res => {
                    if (res.rows.length) {
                        _.forEach(res.rows, item => {
                            item.type = 'cpu'
                        });

                        this.rentList.push(...res.rows);
                    }
                })

                rpc.get_table_rows({
                    json: true,
                    code: 'eosio',
                    scope: 'eosio',
                    table: 'netloan',
                    table_key: '',
                    lower_bound: this.currentAccount,
                    upper_bound: this.currentAccount,
                    index_position: 3,
                    key_type: 'name',
                    limit: 100
                }).then(res => {
                    if (res.rows.length) {
                        _.forEach(res.rows, item => {
                            item.type = 'net'
                        });
                        this.rentList.push(...res.rows);
                    }
                })
            }
        },
        getStakedList() {
            if (this.currentAccount) {
                rpc.get_table_rows({
                    json: true,
                    code: 'eosio',
                    scope: this.currentAccount + ' ',
                    table: 'delband',
                    table_key: '',
                    lower_bound: this.pageStart,
                    upper_bound: '',
                    limit: 10
                }).then(res => {
                    if (res.more) {
                        this.nextPage = true;
                        this.nextPageStart = res.rows[res.rows.length - 1].to;
                    } else {
                        this.nextPage = false;
                    }

                    if (res.rows.length) {
                        this.stakedList = res.rows;
                    }
                });
            }
        },
        showMyStake(type) {

            switch (type) {
                case 'home':
                    this.pageStart = '';
                    this.pageNo = 1;
                    this.previousPage = false;
                    break;
                case 'previous':
                    // this.pageStart = this.pageStart - this.pageCount;
                    this.nextPage = true;
                    this.pageNo--;
                    this.previousPage = this.pageStart !== 1;
                    break;
                case 'next':
                    this.previousPage = true;
                    this.pageNo++;
                    this.pageStart = this.nextPageStart;
                    break;
            }
            this.getStakedList();
        },
        getEosBalance() {
            if (this.currentAccount) {
                rpc.get_table_rows({
                    json: true,
                    code: 'eosio',
                    scope: 'eosio',
                    table: 'cpuloan',
                    table_key: 'time_point',
                    lower_bound: '',
                    upper_bound: '',
                    index_position: 2,
                    key_type: 'i64',
                    limit: 400
                })
                rpc.get_currency_balance("eosio.token", this.currentAccount, SYS_SYMBOL)
                    .then(res => {
                        if (res.length) {
                            this.eosBalance = res[0];
                        }
                    }).catch(err => {
                        console.log(err);
                    });
            }
        },
        getRexFundBalance() {
            if (this.currentAccount) {
                rpc.get_table_rows({
                    json: true,
                    code: 'eosio',
                    scope: 'eosio',
                    table: 'rexfund',
                    table_key: '',
                    lower_bound: this.currentAccount + ' ',
                    upper_bound: this.currentAccount + ' ',
                    limit: 1
                }).then(res => {
                    if (res.rows.length) {
                        this.rexFundBalance = res.rows[0].balance;
                    } else {
                        this.rexFundBalance = '0 ' + SYS_SYMBOL;
                    }
                });
            }
        },
        getAccount() {
            if (this.currentAccount) {
                rpc.get_account(this.currentAccount).then(res => {
                    if (res.voter_info.proxy || res.voter_info.producers.length >= 21) {
                        this.isVoted = true;
                    } else {
                        this.isVoted = false;
                    }
                }).catch(err => {
                    this.isVoted = false;
                })
            }
        },
        getAllInfo() {
            this.getEosBalance();
            // this.getMyRexRecords();
            this.getRexFundBalance();
            this.getRexBalance();
            this.getStakedList();
            this.getRentList();
            this.getAccount();
            this.getMyqueue();

        },
        getRexBalance() {
            if (this.currentAccount) {
                rpc.get_table_rows({
                    json: true,
                    code: 'eosio',
                    scope: 'eosio',
                    table: 'rexbal',
                    table_key: '',
                    lower_bound: this.currentAccount + ' ',
                    upper_bound: this.currentAccount + ' ',
                    limit: 1
                }).then(res => {
                    if (res.rows.length) {
                        this.rexBalance = res.rows[0].rex_balance;
                        this.maturedRex =
                            res.rows[0].matured_rex > 0 ?
                                parseFloat(res.rows[0].matured_rex / 10000).toFixed(4) :
                                0;


                        this.rexMaturities = res.rows[0].rex_maturities;

                        if (this.rexMaturities.length) {
                            _.forEach(this.rexMaturities, item => {
                                item.key = item.key || item.first;
                                item.value = item.value || item.second;

                                let maturedTime = dayjs(item.key + "Z").format("YYYY/MM/DD HH:mm:ss");
                                var now = new Date().getTime();
                                var matime = new Date(maturedTime).getTime();

                                item.isStaked = !!(matime - now > 1000000000000);

                                if (item.isStaked) {
                                    this.rexStaked = parseFloat(item.value / 10000).toFixed(4) + ' REX';
                                }

                                if (now > matime) {
                                    this.maturedRex = parseFloat(parseFloat(this.maturedRex) + item.value / 10000).toFixed(4);
                                }
                            })
                        }
                    } else {
                        this.rexBalance = '0 REX';
                        this.maturedRex = 0;
                        this.rexMaturities = [];
                    }
                });
            }
        },
        transferToRexFund() {
            let amount = parseFloat(this.fundAmount).toFixed(4) + " " + SYS_SYMBOL;

            if (api && this.currentAccount) {
                api.transact({
                    "actions": [
                        {
                            "account": "eosio",
                            "name": "deposit",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                owner: this.currentAccount,
                                amount: amount
                            }
                        }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'))
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        stakeREX() {
            if (api && this.currentAccount && this.mvToSavingAmount) {

                let needToStake = parseFloat(this.mvToSavingAmount).toFixed(4) + ' REX';

                api.transact({
                    "actions": [
                        {
                            "account": "eosio",
                            "name": "mvtosavings",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                owner: this.currentAccount,
                                rex: needToStake
                            }
                        }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'))
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        unstakeREX() {
            if (api && this.currentAccount && this.mvFrSavingAmount) {
                let needToUnstake = parseFloat(this.mvFrSavingAmount).toFixed(4) + ' REX';

                api.transact({
                    "actions": [
                        {
                            "account": "eosio",
                            "name": "mvfrsavings",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                owner: this.currentAccount,
                                rex: needToUnstake
                            }
                        }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'))
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        showMsg(msg) {
            this.msg = msg;
            this.$modal.show('message');
        },
        withdrawFromRexFund() {
            let amount = parseFloat(this.fundWithdrawAmount).toFixed(4) + " " + SYS_SYMBOL;

            if (api && this.currentAccount) {

                api.transact({
                    "actions": [
                        {
                            "account": "eosio",
                            "name": "withdraw",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                owner: this.currentAccount,
                                amount: amount
                            }
                        }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'));
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        syncEosBalance() {
            this.fundAmount = parseFloat(this.eosBalance).toFixed(4);
        },
        syncFundAmount() {
            this.fundWithdrawAmount = parseFloat(this.rexFundBalance).toFixed(4);
        },
        syncRex() {
            this.rexSellAmount = parseFloat(this.maturedRex).toFixed(4);
        },
        syncFund() {
            this.rexAmount = parseFloat(this.rexFundBalance).toFixed(4);
        },
        buyRex() {
            let amount = parseFloat(this.rexAmount).toFixed(4) + " " + SYS_SYMBOL;

            if (api && this.currentAccount) {
                var actions = []

                if (!this.isVoted) {
                    actions.push(
                        {
                            "account": "eosio",
                            "name": "voteproducer",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                voter: this.currentAccount,
                                proxy: DEFAULT_PROXY,
                                producers: []
                            }
                        }
                    )
                }
                actions.push({
                    "account": "eosio",
                    "name": "buyrex",
                    "authorization": [
                        {
                            "actor": this.currentAccount,
                            "permission": this.currentPermission
                        }
                    ],
                    "data": {
                        from: this.currentAccount,
                        amount: amount
                    }
                })

                api.transact({
                    "actions": actions
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'));
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        sellRex() {
            let amount = parseFloat(this.rexSellAmount).toFixed(4) + " REX";

            if (api && this.currentAccount) {
                api.transact({
                    "actions": [
                        {
                            "account": "eosio",
                            "name": "sellrex",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                from: this.currentAccount,
                                rex: amount
                            }
                        }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'));
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        stakedToRex(account, netWeight, cpuWeight) {
            this.unstakedCpuLimit = cpuWeight;
            this.unstakedAccount = account;
            this.unstakedNetLimit = netWeight;

            this.$modal.show('unstakePanel');
        },
        doUnstake() {
            if (api && this.currentAccount) {

                if (!this.unstakedCpu && !this.unstakedNet) {
                    this.showMsg(this.$t('i18nView.postiveAmount'));
                }

                var actions = []

                if (!this.isVoted) {
                    actions.push(
                        {
                            "account": "eosio",
                            "name": "voteproducer",
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                voter: this.currentAccount,
                                proxy: DEFAULT_PROXY,
                                producers: []
                            }
                        }
                    )
                }
                actions.push({
                    "account": "eosio",
                    "name": "unstaketorex",
                    "authorization": [
                        {
                            "actor": this.currentAccount,
                            "permission": this.currentPermission
                        }
                    ],
                    "data": {
                        owner: this.currentAccount,
                        receiver: this.unstakedAccount,
                        from_net: parseFloat(this.unstakedNet).toFixed(4) + ' ' + SYS_SYMBOL,
                        from_cpu: parseFloat(this.unstakedCpu).toFixed(4) + ' ' + SYS_SYMBOL,
                    }
                })

                api.transact({
                    "actions": actions
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'));
                    this.$modal.hide('unstakePanel');
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        rentRes() {
            let resPayment = parseFloat(this.resPayment).toFixed(4) + " " + SYS_SYMBOL;
            let resFund = this.resFund ?
                parseFloat(this.resFund).toFixed(4) + " " + SYS_SYMBOL :
                "0.0000 " + SYS_SYMBOL;
            if (api && this.currentAccount) {

                api.transact({
                    "actions": [
                        {
                            "account": "eosio",
                            "name": this.resType === 'cpu' ? 'rentcpu' : 'rentnet',
                            "authorization": [
                                {
                                    "actor": this.currentAccount,
                                    "permission": this.currentPermission
                                }
                            ],
                            "data": {
                                from: this.currentAccount,
                                receiver: this.resReceiver,
                                loan_payment: resPayment,
                                loan_fund: resFund
                            }
                        }]
                }, {
                    blocksBehind: 3,
                    expireSeconds: 300, // 5分钟
                }).then(res => {
                    this.showMsg(this.$t('i18nView.success'))
                    setTimeout(() => this.getAllInfo(), 1000);
                }).catch(err => {
                    this.handleError(err);
                })
            }
        },
        doResFund(type, detail) {
            var type = type;
            var loadNum = detail.loan_num;
            var resType = detail.type;
            var amount = parseFloat(this.resFundAmount).toFixed(4) + ' ' + SYS_SYMBOL;

            var actionName = '';
            var data = '';

            if (type === 'fund') {
                if (resType === 'cpu') {
                    actionName = 'fundcpuloan';
                    data = {
                        from: this.currentAccount,
                        loan_num: loadNum,
                        payment: amount
                    }

                } else {
                    actionName = 'fundnetloan';
                    data = {
                        from: this.currentAccount,
                        loan_num: loadNum,
                        payment: amount
                    }
                }

            } else {
                if (resType === 'cpu') {
                    actionName = 'defcpuloan';
                    data = {
                        from: this.currentAccount,
                        loan_num: loadNum,
                        amount: amount
                    }
                } else {
                    actionName = 'defnetloan';
                    data = {
                        from: this.currentAccount,
                        loan_num: loadNum,
                        amount: amount
                    }
                }
            }

            api.transact({
                "actions": [
                    {
                        "account": "eosio",
                        "name": actionName,
                        "authorization": [
                            {
                                "actor": this.currentAccount,
                                "permission": this.currentPermission
                            }
                        ],
                        "data": data
                    }]
            }, {
                blocksBehind: 3,
                expireSeconds: 300, // 5分钟
            }).then(res => {
                this.showMsg(this.$t('i18nView.success'))
                setTimeout(() => this.getAllInfo(), 1000);
                this.$modal.hide('resFundPanel');
            }).catch(err => {
                this.handleError(err);
            })

        },
        getRentChart() {
            // if (this.rentChart || !document.getElementById("rent-chart").clientHeight) {
            //     return;
            // }

            // Axios.get(
            //     "https://tbeosapi1.mytokenpocket.vip/v1/token/90?token=t_eosio_rexrentprod"
            // ).then(res => {
            //     if (res.status === 200) {
            //         var time = "1";
            //         var dataArr = res.data;
            //         if (dataArr && dataArr.length) {
            //             var dates = _.map(dataArr, function (item) {
            //                 return dayjs(item["dt"]).format("MM-DD HH:mm");
            //             });

            //             var data = _.map(dataArr, function (item) {
            //                 return [
            //                     parseFloat(item["o"]).toFixed(1),
            //                     parseFloat(item["c"]).toFixed(1),
            //                     parseFloat(item["l"]).toFixed(1),
            //                     parseFloat(item["h"]).toFixed(1)
            //                 ];
            //             });

            //             var option = {
            //                 legend: {
            //                     show: false,
            //                     data: ["K线"],
            //                     inactiveColor: "#777",
            //                     textStyle: {
            //                         color: "#333"
            //                     }
            //                 },
            //                 tooltip: {
            //                     trigger: "axis",
            //                     confine: true,
            //                     // showContent: false,
            //                     axisPointer: {
            //                         animation: false,
            //                         type: "cross",
            //                         lineStyle: {
            //                             color: "#ffffff",
            //                             width: 1,
            //                             opacity: 0.5
            //                         }
            //                     }
            //                 },
            //                 axisPointer: {
            //                     link: {
            //                         xAxisIndex: "all"
            //                     },
            //                     label: {
            //                         backgroundColor: "#333"
            //                     }
            //                 },

            //                 xAxis: [{
            //                     type: "category",
            //                     data: dates,
            //                     axisLabel: {
            //                         color: '#999'
            //                     },
            //                     nameTextStyle: {
            //                         color: '#999'
            //                     }
            //                 }],
            //                 yAxis: [{
            //                     name: SYS_SYMBOL + " * 30D / " + SYS_SYMBOL,
            //                     type: "value",
            //                     scale: true,
            //                     splitLine: {
            //                         show: true,
            //                         lineStyle: {
            //                             opacity: 0.1,
            //                             color: '#999'
            //                         }
            //                     },
            //                     axisLabel: {
            //                         color: '#999'
            //                     },
            //                     nameTextStyle: {
            //                         color: '#999'
            //                     }
            //                 }],
            //                 grid: [{
            //                     top: 30,
            //                     left: 50,
            //                     right: 20,
            //                     bottom: 30
            //                 }],

            //                 animation: false
            //             };
            //             _.assignIn(option, {
            //                 series: [{
            //                     type: "line",
            //                     smooth: true,
            //                     data: _.map(data, item1 => item1[0]),
            //                     lineStyle: {
            //                         color: "#459df5",
            //                         opacity: 0.8
            //                     },
            //                     showSymbol: false
            //                 }]
            //             });

            //             if (!this.rentChart) {
            //                 this.rentChart = echarts.init(
            //                     document.getElementById("rent-chart")
            //                 );
            //             }

            //             this.rentChart.setOption(option);

            //             this.rentChart.hideLoading();
            //         }
            //     }
            // });
            // https://tbeosapi1.mytokenpocket.vip/v1/token/7?token=t_eosio_rex
        },
        getRexChart() {
            // if (this.rexChart || !document.getElementById("rex-chart").clientHeight) {
            //     return;
            //     this.rexChart.showLoading({
            //         text: "加载中..."
            //     });
            // }

            // Axios.get(
            //     "https://tbeosapi1.mytokenpocket.vip/v1/token/90?token=t_eosio_rexprod"
            // ).then(res => {
            //     if (res.status === 200) {
            //         var time = "1";
            //         var dataArr = res.data;
            //         if (dataArr && dataArr.length) {
            //             var dates = _.map(dataArr, function (item) {
            //                 return dayjs(item["dt"]).format("MM-DD HH:mm");
            //             });

            //             var data = _.map(dataArr, function (item) {
            //                 return [
            //                     parseFloat(item["o"]),
            //                     parseFloat(item["c"]),
            //                     parseFloat(item["l"]),
            //                     parseFloat(item["h"])
            //                 ];
            //             });

            //             var option = {
            //                 legend: {
            //                     show: false,
            //                     data: ["K线"],
            //                     inactiveColor: "#777",
            //                     textStyle: {
            //                         color: "#333"
            //                     }
            //                 },
            //                 tooltip: {
            //                     trigger: "axis",
            //                     confine: true,
            //                     // showContent: false,
            //                     axisPointer: {
            //                         animation: false,
            //                         type: "cross",
            //                         lineStyle: {
            //                             color: "#ffffff",
            //                             width: 1,
            //                             opacity: 0.5
            //                         }
            //                     }
            //                 },
            //                 axisPointer: {
            //                     link: {
            //                         xAxisIndex: "all"
            //                     },
            //                     label: {
            //                         backgroundColor: "#333"
            //                     }
            //                 },

            //                 xAxis: [{
            //                     type: "category",
            //                     data: dates,
            //                     axisLabel: {
            //                         color: '#999'
            //                     },
            //                     nameTextStyle: {
            //                         color: '#999'
            //                     }
            //                 }],
            //                 yAxis: [{
            //                     name: SYS_SYMBOL + " / REX",
            //                     type: "value",
            //                     min: function (value) {
            //                         return _.max([value.min - (value.max - value.min) / 5, 0]);
            //                     },
            //                     scale: true,
            //                     splitLine: {
            //                         show: true,
            //                         lineStyle: {
            //                             opacity: 0.1,
            //                             color: '#999'
            //                         }
            //                     },
            //                     axisLabel: {
            //                         color: '#999'
            //                     },
            //                     nameTextStyle: {
            //                         color: '#999'
            //                     }
            //                 }],
            //                 grid: [{
            //                     top: 30,
            //                     left: 65,
            //                     right: 20,
            //                     bottom: 30
            //                 }],
            //                 animation: false
            //             };

            //             if (time === "120m" || time === "1") {
            //                 _.assignIn(option, {
            //                     series: [{
            //                         type: "line",
            //                         smooth: true,
            //                         data: _.map(data, item1 => parseFloat(1 / item1[0]).toFixed(11)),
            //                         lineStyle: {
            //                             color: "#459df5",
            //                             opacity: 0.8
            //                         },
            //                         showSymbol: false
            //                     }]
            //                 });
            //             } else {
            //                 _.assignIn(option, {
            //                     series: [{
            //                         type: "candlestick",
            //                         name: "K线",
            //                         data: data,
            //                         itemStyle: {
            //                             normal: {
            //                                 color: "#28a745",
            //                                 color0: "#dc3545",
            //                                 borderColor: "#28a745",
            //                                 borderColor0: "#dc3545"
            //                             }
            //                         }
            //                     }]
            //                 });
            //             }

            //             if (!this.rexChart) {

            //                 this.rexChart = echarts.init(
            //                     document.getElementById("rex-chart")
            //                 );
            //             }

            //             this.rexChart.setOption(option);

            //             this.rexChart.hideLoading();
            //         }
            //     }
            // });
        },
        fund(rent) {
            this.rentDetail = rent;
            this.rentDetailType = 'fund';
            this.$modal.show('resFundPanel');
            // alert('under going');
        },
        defund(rent) {
            this.rentDetail = rent;
            this.rentDetailType = 'defund';
            this.$modal.show('resFundPanel');
            // alert('under going');
        },
        handleError(err) {
            let errorMsg = err;

            if (typeof err === "string") {
                try {
                    let errJson = JSON.parse(err);
                    if (errJson.error && errJson.error.details.length) {
                        errorMsg = errJson.error.details[0].message;
                    } else if (errJson.error) {
                        errorMsg = errJson.error.what;
                    } else {
                        errorMsg = errJson.message || errJson.code || errJson.msg;
                    }
                } catch (e) {
                    errorMsg = e;
                }
            } else {
                errorMsg = err.message || err.type || err.code;
            }
            this.msg = errorMsg;
            if (_hmt) {
                try {
                    _hmt.push(['_setCustomVar', 2, 'error', errorMsg]);
                }
                catch (err) {
                    console.log(err);
                }
            }

            this.$modal.show('message');
        },
        beforeOpen(event) {
            console.log(event);
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/rex.js